import { buildPjasUri } from '@/func/entityLinks';
import type { Order } from '@/types/types';

/**
 * Compact order snapshot shared by the create wizard and the order details page.
 * Returns `undefined` when there is no order yet so the context key is not published empty.
 */
export function toAutopilotOrder(order: Order | undefined | null) {
  if (!order) return undefined;

  return {
    id: order.id ?? null,
    title: order.title || null,
    status: order.is_draft ? 'draft' : (order.lead_order_status ?? null),
    is_draft: !!order.is_draft,
    company_id: order.company_id ?? null,
    company_name: order.company_name || null,
    workplace_location: order.workplace_location || null,
    workplace_city: order.workplace_city || null,
    workplace_country: order.workplace_country || null,
    language: order.language || null,
    industry: order.industry || null,
    department: order.department || null,
    startdate: order.startdate || null,
    enddate: order.enddate || null,
    workload_fulltime: order.workload_fulltime ?? null,
    workload_min: order.workload_min ?? null,
    workload_max: order.workload_max ?? null,
    workload_permanent: order.workload_permanent ?? null,
    creation_source: order.creation_source || null,
    link: order.id ? buildPjasUri('order', order.id) : null,
  };
}
